export const playlist = {
  'Public playlist': 'Public playlist',
  songs: 'songs',
  Name: 'Name',
  Skills: 'Skills',
  Filter: 'Filter',
};
